// extracted by mini-css-extract-plugin
export default {"container":"TransactionsDashboardLayout_container__hxP5i"};